import React, { useEffect, useMemo, useState } from "react";
import { Box, Flex, Text, Image } from "@chakra-ui/react";

import { columns } from "./data";
import Table from "../../components/table";
import Topbar from "../../components/topbar";
import Searchbar from "../../components/searchbar";
import CustomSelect from "../../components/select";
import useGetBalance from "../../api/queries/useGetBalance";
import MainLayout from "components/mainLayout";
import { useUserContext } from "context/UserContext";
import useGetProducts from "api/queries/useGetProducts";
import { SORT_NEWEST_FIRST, SORT_OLDEST_FIRST } from "utils/constants";

const MyBalance = () => {
  const [balanceData, setBalanceData] = useState([]);
  const { user } = useUserContext();

  const [sortOrder, setSortOrder] = useState(SORT_NEWEST_FIRST);
  const [search, setSearch] = useState("");

  const productsQuery = useGetProducts({
    page: 1,
    limit: 50,
    id: user?.info?._id,
    search,
    // sort,
    // searchObject: {
    //   status: statusFilter,
    //   location: location,
    // },
  });
  const productsData = productsQuery.data?.products ?? [];

  const sellerId = user?.info?._id;
  console.log("🧠 Seller ID:", sellerId);

  const balanceQuery = useGetBalance(sellerId);
  console.log("💰 Balance Query:", balanceQuery);

  const sorted = useMemo(() => {
    const raw = balanceQuery?.data?.data || [];

    // Filter first by product title or SKU
    const filtered = raw.filter((item) => {
      if (!search) return true; // No search -> keep all

      const productTitle =
        item.transaction_id?.product_id?.product_title?.toLowerCase() || "";
      const sku =
        item.transaction_id?.product_id?.variants?.[0]?.sku?.toLowerCase() ||
        "";

      return (
        productTitle.includes(search.toLowerCase()) ||
        sku.includes(search.toLowerCase())
      );
    });

    // Then sort by date_created
    const result = [...filtered].sort((a, b) => {
      const dateA = new Date(a.date_created);
      const dateB = new Date(b.date_created);

      if (sortOrder === SORT_NEWEST_FIRST) {
        return dateB - dateA; // DESC
      } else {
        return dateA - dateB; // ASC
      }
    });

    console.log(
      "Filtered + Sorted balance data:",
      result.map((tx) => ({
        title: tx.transaction_id?.product_id?.product_title,
        sku: tx.transaction_id?.product_id?.variants?.[0]?.sku,
        date: tx.date_created,
      })),
    );

    return result;
  }, [balanceQuery?.data?.data, sortOrder, search]);

  useEffect(() => {
    setBalanceData(sorted);
  }, [sorted]);

  const totalBalance =
    balanceQuery?.data?.data?.reduce((total, item) => {
      const type = item?.transaction_id?.transaction_type_id?.name;
      const amount = Number(item?.amount) || 0;

      // Match AMOUNT column logic: seller-commission and dry-cleaning-cost-removed are positive, all others negative
      if (
        type === "seller-commission" ||
        type === "seller_commission" ||
        type === "dry-cleaning-cost-removed"
      ) {
        return total + amount;
      } else {
        return total - Math.abs(amount);
      }
    }, 0) || 0;

  //Round Balance

  const roundedBalance = Math.round(totalBalance * 100) / 100;

  return (
    <MainLayout h={"100%"} minH={"100vh"} paddingBottom={20}>
      <Box>
        <Topbar title={"My Balance"} />

        {/* Top section with Balance Card */}
        <Flex
          bg={"#f8fbff"}
          padding={8}
          height={"100%"}
          gap={2}
          justifyContent={"space-between"}
          alignItems={"center"}
          flexWrap="wrap"
        >
          <Box bg={"#FFFFFF"} padding={4} borderRadius={"10px"} width={"360px"}>
            <Flex align={"center"} gap={2}>
              <Image
                src={require("assets/svgs/wallet.svg").default}
                width={8}
                height={8}
              />
              <Text
                fontSize={"14px"}
                lineHeight={"24px"}
                fontFamily={"PlusJakartaSansMedium"}
                color={"#9A9FA3"}
              >
                Your Balance
              </Text>
            </Flex>
            <Text
              fontSize={"24px"}
              lineHeight={"32px"}
              fontFamily={"PlusJakartaSansBold"}
              color={
                roundedBalance === 0
                  ? "#9A9FA3"
                  : roundedBalance < 0
                    ? "red"
                    : "#099E4A"
              }
            >
              £{Math.abs(roundedBalance).toFixed(2)}
              {roundedBalance !== 0 && (roundedBalance < 0 ? " Dr" : " Cr")}
            </Text>
          </Box>

          {/* Search & Sort */}
          <Flex gap={3} align={"center"}>
            <Searchbar onChange={setSearch} title={"Search"} />
            <CustomSelect
              label={"Sort"}
              onChange={setSortOrder}
              style={{ maxWidth: "200px" }}
              inputStyle={{
                border: "none",
                background: "#fff",
                color: "#898989",
                fontSize: "14px",
                fontFamily: "PlusJakartaSansMedium",
              }}
            >
              <option value={SORT_NEWEST_FIRST}>Newest First</option>
              <option value={SORT_OLDEST_FIRST}>Oldest First</option>
            </CustomSelect>
          </Flex>
        </Flex>

        {/* Table */}
        <Box
          minW={"100%"}
          w={"1px"}
          overflowX={"auto"}
          padding={8}
          paddingTop={0}
          bg={"#f8fbff"}
        >
          {balanceQuery.isLoading ? (
            <Text fontSize="lg">Loading Balance...</Text>
          ) : (
            <Table data={balanceData} columns={columns} />
          )}
        </Box>
      </Box>
    </MainLayout>
  );
};

export default MyBalance;
